import { useNavigate } from "react-router-dom";
import { ModalProps } from "../../interfaces/modal";
import { logout } from "../../api/login";
import { showToastError } from "../../services/toast";
import { useCrmStore } from "../../stores/crm";
import { useStaffStore } from "../../stores/staff";
import { usePaymentStore } from "../../stores/payment";
import { useInvoiceStore } from "../../stores/invoice";
import { useUserContext } from "../../contexts/userContext";
import {
  ModalButton,
  ModalConfirmText,
  ModalShell,
} from "../ui/modals/ModalShell";

const Logout: React.FC<ModalProps> = ({ closeModal }) => {
  const navigate = useNavigate();
  const { resetCrm } = useCrmStore();
  const { resetStaff } = useStaffStore();
  const { resetPayment } = usePaymentStore();
  const { resetInvoice } = useInvoiceStore();
  const { resetUserContext } = useUserContext();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Appel API
    logout()
      .then(() => {
        navigate("/");
        closeModal();
        resetCrm();
        resetStaff();
        resetPayment();
        resetInvoice();
        resetUserContext();
      })
      .catch(() => {
        showToastError("Une erreur est survenue");
      });
  };

  return (
    <ModalShell
      title="Déconnexion"
      size="sm"
      onClose={() => closeModal()}
      footer={
        <>
          <ModalButton variant="secondary" onClick={() => closeModal()}>
            Annuler
          </ModalButton>
          <ModalButton variant="primary" type="submit" onClick={handleSubmit}>
            Déconnexion
          </ModalButton>
        </>
      }
    >
      <ModalConfirmText>
        Etes-vous sûr de bien vouloir vous déconnecter ?
      </ModalConfirmText>
    </ModalShell>
  );
};

export default Logout;
